






































import { AxiosResponse } from "axios";
import Vue, { VueConstructor } from "vue";
import EventQuery from "@/mixins/EventQuery";
import { formatDate, toHHMMSS } from "@/lib/utils";
import { TroubleDoc } from "@/types";

// Teach TypeScript about mixins
// see: https://forum.vuejs.org/t/using-mixins-with-typescript/24256/18
export default (Vue as VueConstructor<
  Vue & InstanceType<typeof EventQuery>
>).extend({
  name: "Runs",
  mixins: [EventQuery],
  data() {
    return {
      events: [] as Array<TroubleDoc>,
    };
  },
  watch: {
    timeRangeQuery() {
      this.loadData();
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.fetch("/live/events", (response: AxiosResponse) => {
        response.data.events.reverse();
        this.events = response.data.events;
      });
    },
    formatDate: formatDate,
    toHHMMSS: toHHMMSS,
  },
});
